<template>
  <v-tabs>
    <v-tab><h2>瀏覽</h2></v-tab>
    <v-tab-item class="pa-1 pa-sm-4">
      <!-- Options -->
      <v-row>
        <v-col sm="12" md="9" class="pb-0 pt-0">
          <v-row class="my-group-detail-combobox">
            <v-col>
              <v-combobox
                label="類別"
                v-model="optionSelected1"
                :items="!isSending ? groupListOptions : []"
                @change="handleOnChangeOption1"
              ></v-combobox>
            </v-col>
            <v-col>
              <v-combobox
                label="品牌"
                v-model="optionSelected2"
                :items="!isSending ? options2 : []"
                @change="handleOnChangeOption2"
              ></v-combobox>
            </v-col>
            <v-col>
              <v-combobox
                label="系列"
                v-model="optionSelected3"
                :items="!isSending ? options3 : []"
              ></v-combobox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- Table -->
      <v-row>
        <v-col sm="12" md="9" class="pb-0 pt-0">
          <v-data-table
            :headers="headers"
            item-key="d_id"
            :items="!isSending ? listByOption3 : []"
            class="elevation-4 my-group-detail-table"
            :search="tableSearch"
            :loading="isSending"
            loading-text="資料更新中..."
            no-data-text="暫無資料"
            no-results-text="沒有匹配的資料"
            show-select
            v-model="tableCBSelected"
            :mobile-breakpoint="tableModes[tableMode].breakpoint"
          >
            <template v-slot:item.tag="{ item }">
              {{ item.tag === 1 ? '代理群組' : '會員群組' }}
            </template>
            <template v-slot:top>
              <v-row dense>
                <v-col v-if="tag === 1">
                  <v-combobox
                    label="群組類型"
                    :items="options4"
                    class="mx-4"
                    v-model="optionSelected4"
                    @change="handleOnChangeOption4"
                  ></v-combobox>
                </v-col>
                <v-col>
                  <v-combobox
                    label="群組"
                    :items="!isSending ? options5 : []"
                    class="mx-4"
                    v-model="optionSelected5"
                    @change="handleOnChangeOption5"
                  ></v-combobox>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-text-field
                    v-model="tableSearch"
                    label="快速搜尋"
                    class="mx-4"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.u_price="{ item }">
              {{ getUniquePrice(item) }}
            </template>
            <template v-slot:item.o_price="{ item }">
              {{
                groupDetailsOwn[item.d_id]
                  ? groupDetailsOwn[item.d_id].u_price
                  : item.price +
                    (groupDetailOwnPremium > 0
                      ? groupDetailOwnPremium
                      : Math.round(item.price * (groupDetailOwnPremiumP / 100)))
              }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" @click="handleOnEditAddOne(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-tab-item>
    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h3>{{ dialogMode ? '新增獨立價格' : '編輯獨立價格' }}</h3>
        </v-card-title>
        <!--  -->
        <v-card-text>
          <v-form
            ref="form"
            lazy-validation
            v-model="dialogInputValid"
            @submit.prevent=""
          >
            <v-row>
              <v-col>
                <v-text-field
                  v-model="price"
                  label="原始價格"
                  :rules="dialogNumberRules"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="unique_price"
                  label="獨立價格"
                  :rules="dialogNumberRules"
                  require
                ></v-text-field>
              </v-col>
            </v-row>
            <v-switch
              v-model="enb"
              inset
              color="primary"
              :label="`狀態:${enb ? '啟用' : '關閉'}`"
            ></v-switch>
          </v-form>
        </v-card-text>
        <!--  -->
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn elevation="4" color="error" @click="dialog = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-end">
              <v-btn
                elevation="4"
                color="success"
                @click="handleOnDialogSave"
                :disabled="isSending"
              >
                <v-icon>mdi-check-bold</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <!--  -->
        <v-progress-linear
          :active="isSending"
          indeterminate
          absolute
          bottom
        ></v-progress-linear>
      </v-card>
    </v-dialog>
  </v-tabs>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapActions, mapState } from 'vuex'
export default {
  data: () => {
    return {
      // #region Dialog
      dialog: false,
      dialogInputValid: false,
      dialogMode: true,
      dialogOnSaveFn: undefined,
      dialogInputRules: [
        v => !!v || '不可空白',
        v => v.length <= 20 || '字數不可超過20個字'
      ],
      dialogNumberRules: [
        v => Number(v) >= 0 || '必須是正整數',
        v => Number.isInteger(Number(v)) || '必須是整數',
        v => !!v || '不可空白'
      ],
      enb: true,
      price: '',
      unique_price: '',
      // #endregion
      // #region Combobox
      optionSelected1: '',
      optionSelected2: '',
      optionSelected3: '',
      options4: [],
      optionSelected4: '',
      optionSelected5: '',
      // #endregion
      // #region Table
      tableSearch: '',
      tableCBSelected: [],
      headers: [
        {
          text: '型號',
          align: 'start',
          value: 'model'
        },
        {
          text: '價格',
          align: 'start',
          value: 'price'
        },
        {
          text: '代理價格',
          align: 'start',
          value: 'o_price'
        },
        {
          text: '獨立溢價',
          align: 'start',
          value: 'u_price'
        },
        {
          text: '',
          align: 'start',
          value: 'actions'
        }
      ],
      // #endregion
      // #region
      // #endregion
      nothing: undefined
    }
  },
  computed: {
    ...mapState('account', ['uid', 'user', 'level']),
    ...mapState('admin', [
      'tag',
      'isSending',
      'groupListOptions',
      'groupBrandOptions',
      'groupSeriesOptions',
      'groupOptions',
      'groupListDetails',
      'groupDetails',
      'groupDetailsOwn',
      'groupDetailOwnPremium',
      'groupDetailOwnPremiumP',
      'tableModes',
      'tableMode'
    ]),
    options2() {
      const o = []
      if (!this.optionSelected1) return o
      if (this.optionSelected1.value === undefined) return o
      // o.push({ text: '所有品牌', value: 0 })
      const id = this.optionSelected1.value
      this.groupBrandOptions.forEach(e => {
        if (e.l_id === id) o.push(e)
      })
      if (o.length > 0) o.unshift({ text: '所有品牌', value: 0 })
      return o
    },
    options3() {
      const o = []
      if (!this.optionSelected2) return o
      if (this.optionSelected2.value === undefined) return o
      const id = this.optionSelected2.value
      // if (id === 0) return this.groupSeriesOptions
      this.groupSeriesOptions.forEach(e => {
        if (e.b_id === id || id === 0) o.push(e)
      })
      if (o.length > 0) o.unshift({ text: '所有系列', value: 0 })
      return o
    },
    options5() {
      const o = []
      if (!this.optionSelected4) return o
      if (this.optionSelected4.value === undefined) return o
      const tag = this.optionSelected4.value
      if (tag === 0) return this.groupOptions
      this.groupOptions.forEach(e => {
        if (e.tag === tag) o.push(e)
      })
      return o
    },
    listByOption3() {
      const o = []

      if (!this.optionSelected2) return o
      if (this.optionSelected2.value === undefined) return o
      if (!this.optionSelected3) return o
      if (this.optionSelected3.value === undefined) return o

      const b_id = this.optionSelected2.value
      const s_id = this.optionSelected3.value

      this.groupListDetails.forEach(e => {
        if (
          (e.b_id === b_id || b_id === 0) &&
          (e.s_id === s_id || s_id === 0)
        ) {
          o.push(e)
        }
      })

      // if (s_id === 0) return this.groupListDetails
      // this.groupListDetails.forEach(e => {
      //   if (e.s_id === s_id) o.push(e)
      // })
      return o
    }
  },
  methods: {
    ...mapActions('admin', [
      'getAllGroupDetails',
      'getOneGroupDetail',
      'getOneGroupDetailByGroup',
      'updateGroupDetail'
    ]),
    handleOnChangeOption1() {
      ;(async () => {
        const { level, user, uid } = this
        await this.getOneGroupDetail({
          l_id: this.optionSelected1.value,
          level,
          user,
          uid
        })
        this.$nextTick(async () => {
          this.optionSelected2 = this.options2[0]
          this.optionSelected3 = this.options3[0]
        })
      })()
    },
    handleOnChangeOption2() {
      this.optionSelected3 = this.options3[0]
    },
    handleOnChangeOption4() {
      if (this.options5.length < 1) return
      this.optionSelected5 = this.options5[0]
      this.handleOnChangeOption5()
    },
    handleOnChangeOption5() {
      if (!this.optionSelected5) return
      if (!this.optionSelected5.value) return
      ;(async () => {
        const { level, user, uid } = this
        await this.getOneGroupDetailByGroup({
          g_id: this.optionSelected5.value,
          l_id: this.optionSelected1.value,
          level,
          user,
          uid
        })
        // this.$nextTick(async () => {
        //   this.optionSelected5 = this.options5[0]
        // })
      })()
    },
    // eslint-disable-next-line no-unused-vars
    handleOnEditAddOne(item) {
      if (!this.optionSelected5) return
      const tempOS = this.optionSelected5
      let g_d_id = ''
      this.price = item.price
      if (!this.groupDetails[item.d_id]) {
        // New
        this.dialogMode = true
        this.unique_price = ''
        this.enb = true
      } else {
        // Update
        this.dialogMode = false
        this.unique_price = this.groupDetails[item.d_id].u_price
        this.enb = this.groupDetails[item.d_id].enb
        g_d_id = this.groupDetails[item.d_id].id
      }

      this.dialog = true

      this.dialogOnSaveFn = async () => {
        if (!this.dialogInputValid) return
        if (!this.unique_price) return
        if (g_d_id) {
          let eb = this.groupDetails[item.d_id].enb ? true : false
          if (
            this.unique_price === this.groupDetails[item.d_id].u_price &&
            this.enb === eb
          )
            return
        }

        this.optionSelected5 = ''
        const { level, user, uid } = this
        await this.updateGroupDetail({
          d_id: item.d_id,
          g_id: tempOS.value,
          id: g_d_id,
          u_price: this.unique_price,
          enb: this.enb ? 1 : 0,
          level,
          user,
          uid
        })
        this.$nextTick(async () => {
          this.optionSelected5 = tempOS
          this.dialog = false
        })
      }
    },
    // Dialog
    handleOnDialogSave() {
      if (this.dialogOnSaveFn) this.dialogOnSaveFn()
    },
    // Table
    getUniquePrice(item) {
      if (!this.groupDetails[item.d_id]) return '未設定'
      if (!this.groupDetails[item.d_id].enb) return '已停用'
      return this.groupDetails[item.d_id].u_price
    }
  },
  created() {
    this.$emit('setTopLabel', 5)

    if (this.level < 6) {
      this.options4 = [
        { text: '所有群組', value: 0 },
        { text: '代理群組', value: 1 },
        { text: '會員群組', value: 2 }
      ]
      this.optionSelected4 = this.options4[0]
    } else if (this.level > 5 && this.level < 10) {
      this.options4 = [{ text: '會員群組', value: 2 }]
      this.optionSelected4 = this.options4[0]
    }
    //
    ;(async () => {
      const { level, user, uid } = this
      await this.getAllGroupDetails({ level, user, uid })
      this.$nextTick(() => {
        if (this.groupListOptions.length < 1) return
        this.optionSelected1 = this.groupListOptions[0]

        if (this.options2.length < 1) return
        this.optionSelected2 = this.options2[0]

        if (this.options3.length < 1) return
        this.optionSelected3 = this.options3[0]

        if (this.options5.length < 1) return
        this.optionSelected5 = this.options5[0]
      })
    })()
  }
}
</script>

<style lang="scss">
.my-group-detail-table {
  // th {
  //   min-width: 60px;
  // }

  th,
  td {
    font-size: 18px;
  }
}

@media screen and (max-width: 600px) {
  .my-group-detail-combobox {
    .col {
      padding-bottom: 0px !important;
    }

    .v-input {
      label,
      input {
        font-size: 20px;
      }
    }
  }

  .my-group-detail-table {
    .v-input {
      label,
      input {
        font-size: 20px;
      }
    }

    th {
      vertical-align: top !important;
    }

    table tr .text-start:nth-child(n + 3) {
      text-align: right !important;
    }

    th,
    td {
      padding-right: 2px !important;
      padding-left: 2px !important;
    }

    .v-data-footer {
      .v-data-footer__select {
        margin-right: 0px;
      }
    }
  }
}
</style>
